<template>
  <footer class="main-footer">
    <div class="pull-right hidden-xs">
      {{ $t('footer.text-right') }}
    </div>
    <!-- Default to the left -->
    <strong>{{ $t('footer.copyright') }} <a target="_blank" href="https://sportlane.com">Sportlane.com</a>.</strong>
    {{ $t('footer.all-rights-reserved') }}
  </footer>
</template>

<script>
export default {
  name: 'Footer'
};
</script>

<style scoped>

</style>
